/* eslint-disable import/first */
import React, { useState, useRef, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Typography, TextField, FormControlLabel, Checkbox, Button, InputAdornment } from '@material-ui/core';
import ClassNames from 'classnames';
import icon from './images/icon.svg';
import handIcon from './images/handIcon.svg';
const { cookieData } = Slices.cartSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';

export default function CookingInstructions({
  title = '',
  placeholder = '',
  note = '',
  maxLength = 80,
  classname,
  foodInstr,
}) {
  const dispatch = useDispatch();
  const [inputFocus, setInputFocus] = useState(false);
  const cookingValue = useSelector((state) => state.cart.cookingData);
  const [textValue, setTextValue] = useState(cookingValue ? cookingValue : '');
  const [saveForFuture, setSaveForFuture] = useState(
    localStorage.getItem('saveForFuture') === 'true'
  );

  const intl = useIntl();
  const wrapperRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const eventClickOutsideDiv = (event) => {
    if (!wrapperRef.current) return;
    // CLICK IN_SIDE
    if (!inputFocus || wrapperRef.current.contains(event.target)) {
      return;
    }
    // CLICK OUT_SIDE
    setInputFocus(false);
  };

  useEffect(() => {
    if (eventClickOutsideDiv) {
      document.removeEventListener('click', eventClickOutsideDiv);
    }
    inputFocus && document.addEventListener('click', eventClickOutsideDiv);
    return () => {
      document.removeEventListener('click', eventClickOutsideDiv);
    };
  }, [eventClickOutsideDiv, inputFocus]);

  const handleInputFocus = (e) => {
    setInputFocus(true);
  };
  useEffect(() => {
    if (inputFocus) {
      document.getElementById('cookingInput').focus();
    } else {
      dispatch(cookieData(textValue.trim()));
    }
  }, [dispatch, inputFocus, textValue]);

  const onChangeText = (e) => {
    setTextValue(e.target.value);
    localStorage.setItem('cookingValue', e.target.value);
  };

  const handleDoneClick = (e) => {
    setInputFocus(!inputFocus);
    setTextValue(textValue.trim());
    dispatch(cookieData(textValue.trim()));
  };

  const handleSaveForFuture = (e) => {
    setSaveForFuture(e.target.checked);
    localStorage.setItem('saveForFuture', e.target.checked);
  };
  const clearInstruction = () => {
    setTextValue('');
    localStorage.setItem('cookingValue', '');
  };
  return (
    <div className={ClassNames(css.root, { [classname]: classname })}>
      {(textValue || inputFocus) &&
        <div className={css.labelText}>
          <span className={css.placeholderText}>{placeholder}</span>
          {!inputFocus &&
            <span className={css.editBtn} onClick={handleDoneClick}>
              <FormattedMessage id="cart_edit" defaultMessage="EDIT" />
            </span>
          }
        </div>
      }
      <div className={css.inputWrapper}>
        <div className={css.icon}>
          <img src={icon} alt="Cooking instructions icon" />
        </div>
        <div className={css.input}>
          {!inputFocus && (
            <div className={css.cookingInput}>
              <TextField
                value={textValue || localStorage.getItem('cookingValue')}
                name="instructions"
                // label=""
                fullWidth
                placeholder={placeholder}
                onChange={(e) => onChangeText(e)}
                inputProps={{
                  maxLength,
                  onFocus: handleInputFocus,
                }}
              />
            </div>
          )}
          {inputFocus && (
            <>
              <div className={css.characterCount}>
                <TextField
                  id="cookingInput"
                  value={textValue || localStorage.getItem('cookingValue')}
                  name="instructions"
                  label=""
                  fullWidth
                  placeholder={intl.formatMessage({ id: 'cooking_inst_placeholder' })}
                  onChange={(e) => onChangeText(e)}
                  onClick={handleInputFocus}
                  inputProps={{
                    maxLength,
                    onFocus: handleInputFocus,
                  }}
                  InputProps={{
                    endAdornment: textValue !== '' ? <InputAdornment position='end'><Button onClick={clearInstruction} className={css.close}>x</Button></InputAdornment> : ''
                  }}
                  ref={wrapperRef}
                  autoComplete="off"
                />
                {/* {textValue !== '' ? (
                  <Button onClick={clearInstruction} className={css.close}>
                    x
                  </Button>
                ) : (
                  ''
                )} */}
                <div className={css.countText}>
                  <span className={css.usedCharacters}>
                    {textValue === '' ? 0 : parseInt(maxLength) - parseInt(textValue?.length)}
                  </span>
                  <span className={css.characterCountSeparator}>/</span>
                  <span className={css.maxCharacters}>{maxLength}</span>
                </div>
              </div>
              <div className={css.note}>
                <div>{note}</div>
              </div>
            </>
          )}
        </div>
      </div>

      {(inputFocus) && (
        <div className={css.actionBar}>
          <FormControlLabel
            control={
              <Checkbox
                checked={saveForFuture}
                onChange={handleSaveForFuture}
                color="primary"
                name="saveforfuture"
              />
            }
            label={intl.formatMessage({ id: 'cart_saveforfuture' })}
          />
          <Button
            variant="contained"
            color="primary"
            className={css.done}
            fullWidth
            onClick={handleDoneClick}
          >
            <FormattedMessage id="trackorder_done" defaultMessage="Done" />
          </Button>
        </div>
      )}
    </div>
  );
}
